import React, { ReactNode } from 'react'

export interface TooltipProps {
  children: ReactNode
  tip: string
  position?: 'top' | 'bottom' | 'left' | 'right'
}

export default function Tooltip({ tip, children, position = 'top' }: TooltipProps) {
  const tooltipClass = `tooltip tooltip-${position}`

  return (
    <div tabIndex={0} className={`${tooltipClass} [&:before]:!text-xs [&:after]:!text-xs z-50`} data-tip={tip}>
      {children}
    </div>
  )
}
